import React from "react";
import { cn } from "@/lib/utils";

/**
 * Container — centered max-width wrapper with consistent horizontal padding.
 */
export const Container = ({ className, children, ...props }) => {
  return (
    <div
      className={cn("mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-10", className)}
      {...props}
    >
      {children}
    </div>
  );
};
